import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M5.81299 34.9588V19.9589H34.1462V34.9588H5.81299ZM7.90695 32.8648H32.0523V22.0528H7.90695V32.8648Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map